import { render, staticRenderFns } from "./SaleReportKomisi.vue?vue&type=template&id=453d8681"
import script from "./SaleReportKomisi.vue?vue&type=script&lang=js"
export * from "./SaleReportKomisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports